var React = require('react');

function Rightarrow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a8dae53e-f201-4275-b36f-aab8ce00be4c{fill:#f7f8f3;}")),React.createElement("title",{"key":1},"rightarrow"),React.createElement("g",{"id":"a6cdd28c-04e3-4deb-b99c-651856b154a6","data-name":"Capa 2","key":2},React.createElement("g",{"id":"a137d8f2-0aa8-4b49-8e08-4b479d00df2a","data-name":"Capa 1"},[React.createElement("path",{"className":"a8dae53e-f201-4275-b36f-aab8ce00be4c","d":"M45,8A37,37,0,1,1,8,45,37,37,0,0,1,45,8m0-8A45,45,0,1,0,90,45,45,45,0,0,0,45,0Z","key":0}),React.createElement("path",{"className":"a8dae53e-f201-4275-b36f-aab8ce00be4c","d":"M50,65.83a4,4,0,0,1-3-6.65L56,49H21.67a4,4,0,0,1,0-8H56.14L47.59,30.72a4,4,0,0,1,6.08-5.19L68.17,42a4,4,0,0,1,0,5.29L53,64.48A4,4,0,0,1,50,65.83Z","key":1})]))]);
}

Rightarrow.defaultProps = {"viewBox":"0 0 90 90"};

module.exports = Rightarrow;

Rightarrow.default = Rightarrow;
